import {
  Button,
  Form,
  Input,
  Modal,
  Card,
  message,
  Spin,
  Radio,
  Divider,
  Row,
  Col,
  InputNumber,
  Select,
} from "antd";
import {
  baseUrl,
  GET_LAWSUIT_DETAIL_BY_LOAN,
  GET_LOAN_BY_CONTNO,
  HEADERS_EXPORT,
  HEADERS_EXPORT_BEN,
  POST_LITIGATION_FUNDS,
  POST_LOAN_DB2,
  POST_MEMO,
  POST_PRE_INVESTIGATE_LOG,
  PUT_INVESTIGATE_LOG,
} from "../../../API/apiUrls";
import axios from "axios";
import dayjs from "dayjs";
import DateCustom from "../../../../hook/DateCustom";
import CurrencyFormat from "../../../../hook/CurrencyFormat";
import React, { useEffect, useMemo, useState } from "react";
import LoadLawyers from "../../../../hook/LoadLawyers";

const SendToLawsuit = ({
  open,
  close,
  dataDefault,
  funcUpdateStatus,
  statusModal,
}) => {
  const userId = parseInt(localStorage.getItem("USER_ID"));
  const userCompany = localStorage.getItem("COMPANY_ID");
  const [lawyersList, setLoadingData, loadLawyerJobs] = LoadLawyers();
  const [lawyersOption, setLawyersOption] = useState();
  const [dataJobsLawyer, setDataJobsLawyer] = useState();
  const [convertDateThai, convertDateThaiShort] = DateCustom();
  const [
    currencyFormat,
    currencyFormatComma,
    currencyFormatPoint,
    currencyFormatNoPoint,
  ] = CurrencyFormat();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [isModal, setIsModal] = useState(false);
  const [loading, setLoading] = useState();
  const [arrow, setArrow] = useState("Show");
  const [radioStatus, setRadioStatus] = useState();
  const [dataLeasingCase, setDataLeasingCase] = useState();
  const [dataLoadLawsuit, setDataLoadLawSuit] = useState();
  const [jobCount, setJobCont] = useState();

  const options = dataLeasingCase
    ? [
        {
          label: `${currencyFormatComma(dataLeasingCase?.usableCapital)} บาท`,
          value: dataLeasingCase?.usableCapital,
        },
        ...(dataLeasingCase?.litigation_capital !==
          dataLeasingCase?.usableCapital &&
        dataLeasingCase?.usableCapital >= 300000
          ? [
              {
                label: `${currencyFormatComma(
                  dataLeasingCase?.litigation_capital
                )} บาท`,
                value: dataLeasingCase?.litigation_capital,
              },
            ]
          : dataLeasingCase?.usableCapital < 300000
          ? []
          : [
              {
                label: `300,000 บาท`,
                value: 300000,
              },
            ]),
      ]
    : [{ label: "ไม่พบข้อมูล", value: 0 }];

  useEffect(() => {
    setIsModal(open);
    if (isModal) {
      loadData();
      console.log("loadData", dataDefault);
    }
  }, [isModal]);

  const handleSetField = (data) => {
    if (data?.litigation_funds) {
      form.setFieldsValue({
        intigationFounds: data?.litigation_funds,
        courtFee: data?.fee,
        lostProfitAmount: data?.lack_of_benefits,
      });
    }
  };

  useEffect(() => {
    setLoadingData(true);
  }, [setLoadingData]);

  useEffect(() => {
    if (lawyersList && loadLawyerJobs) {
      setOption();
      setJobsLawyer();
    }
  }, [lawyersList, loadLawyerJobs]);

  const setOption = () => {
    let companySelect = null;

    if (userCompany === "1" || userCompany === "2") {
      companySelect = lawyersList.filter(
        (item) =>
          (item.COMPANY_ID === 1 || item.COMPANY_ID === 2) &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    } else {
      companySelect = lawyersList.filter(
        (item) =>
          item.COMPANY_ID === 3 &&
          item.ROLE_ID === 3 &&
          item.ACTIVE_STATUS === 1
      );
    }
    const options = companySelect.map((item) => ({
      value: item.id,
      label: item.NNAME,
    }));
    console.log("options", options);

    setLawyersOption(options);
  };

  const setJobsLawyer = () => {
    const filtered = loadLawyerJobs.filter(
      (item) => item.COMPANY_ID !== 3 && item.ACTIVE_STATUS === 1
    );
    console.log(filtered);

    const minJobUser =
      filtered.length > 0
        ? filtered.reduce((min, item) =>
            item.USER_JOBS < min.USER_JOBS ? item : min
          )
        : null;

    if (!minJobUser) return;
    setJobCont(minJobUser.USER_JOBS);
    console.log("minJobUser", minJobUser);
    setDataJobsLawyer(minJobUser);
    form.setFieldsValue({ lawyerChoose: Number(minJobUser.USER_ID) }); // <- สำคัญมาก
  };

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }
    if (arrow === "Show") {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, []);

  const handleCancel = () => {
    console.log("Clicked cancel button");
    close(false);
    setIsModal(false);
  };

  const loadData = async () => {
    setLoading(true);
    try {
      const [lawsuitRes, leasing] = await Promise.all([
        axios.get(
          `${baseUrl}${GET_LAWSUIT_DETAIL_BY_LOAN}${dataDefault.LOAN_ID}`,
          {
            headers: HEADERS_EXPORT,
          }
        ),
        axios.post(
          POST_LITIGATION_FUNDS,
          {
            contno: dataDefault.CONTNO,
            type: dataDefault.DATA_TYPE.toUpperCase(),
            todate: dayjs().format("YYYY-MM-DD"),
            asset:
              dataDefault.investigationStatus === 7 ||
              dataDefault.investigationStatus === 1
                ? "1"
                : "1",
          },
          {
            headers: HEADERS_EXPORT_BEN,
          }
        ),
      ]);

      if (lawsuitRes.status === 200) {
        console.log("lawsuitRes", lawsuitRes.data);
        handleSetField(lawsuitRes.data);
        setDataLoadLawSuit(lawsuitRes.data);
      } else {
        message.error("ไม่พบข้อมูลคดี");
      }
      if (leasing.status === 200) {
        console.log("leasing", leasing.data[0]);
        setDataLeasingCase(leasing.data[0]);
      } else {
        message.error("ไม่พบข้อมูลสัญญาในระบบ");
      }
    } catch (error) {
      console.error("Error loading data:", error);
      message.error(`ไม่พบข้อมูล: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };
  console.log("statusModal", statusModal);

  const sendData = async (dataLawsuit, assignedJob) => {
    setLoading(true);
    //  .post(
    // "http://localhost:8080/lawyer/dev/api/pre-investigate-assets",
    try {
      await axios
        .post(
          baseUrl + POST_PRE_INVESTIGATE_LOG,
          {
            status: statusModal,
            data: [assignedJob],
            dataLawsuit: statusModal === 2 ? dataLawsuit : {},
          },
          {
            headers: HEADERS_EXPORT,
          }
        )
        .then(async (resQuery) => {
          if (resQuery.status === 201) {
            console.log("resQuery", resQuery.data);
            funcUpdateStatus();
          } else {
            console.log(`Contract No. Not Found`);

            return null;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("เกิดข้อผิดพลาดในการดึงข้อมูล");
    } finally {
      console.log("โหลดข้อมูลสำเร็จ");
      setLoading(false);
      handleCancel();
    }
  };

  const onFinish = (values) => {
    console.log("Success:", values);
    const dataLawsuit = {
      ...dataLoadLawsuit,
      lack_of_benefits: values.lostProfitAmount,
      fee: values.courtFee,
      litigation_funds: values.intigationFounds,
      pre_litigation_funds: values.intigationFounds,
      mark: values.memo,
    };
    console.log("dataLawsuit", dataLawsuit);

    // ⏺ อัปเดต row
    const assignedJob = { ...dataDefault, USER_ID: values.lawyerChoose };
    console.log("assignedRows", assignedJob);

    sendData(dataLawsuit, assignedJob);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครับ");
  };

  const onChangeInputMemo = (value) => {
    console.log(value);
  };

  const onChangeInvestiGateResult = ({ target: { value } }) => {
    setRadioStatus(value);
    let calFeeCourt;
    if (value <= 300000) {
      calFeeCourt = value * 0.02;
      if (calFeeCourt > 1000) {
        calFeeCourt = 1000;
      }
    } else {
      calFeeCourt = value * 0.02;
    }
    let lostBenefit;

    if (dataLeasingCase.usableCapital !== 300000) {
      if (dataLeasingCase.usableCapital === value) {
        console.log("if", dataLeasingCase.lost_profit_amount);
        form.setFieldsValue({
          lostProfitAmount: dataLeasingCase.lost_profit_amount,
        });
      } else {
        lostBenefit =
          300000 - (dataLeasingCase.balanc - dataLeasingCase.netpay);
        form.setFieldsValue({
          lostProfitAmount: lostBenefit < 0 ? 0 : lostBenefit,
        });
        console.log(lostBenefit);
      }
    } else {
      if (dataLeasingCase.usableCapital === value) {
        console.log("if", dataLeasingCase.lost_profit_amount);
        form.setFieldsValue({
          lostProfitAmount: dataLeasingCase.lost_profit_amount,
        });
      } else {
        lostBenefit = dataLeasingCase.balanc - dataLeasingCase.netpay;
        form.setFieldsValue({
          lostProfitAmount: lostBenefit < 0 ? 0 : lostBenefit,
        });
        console.log(lostBenefit);
      }
    }

    form.setFieldsValue({
      intigationFounds: value,
      courtFee: calFeeCourt ? Math.ceil(calFeeCourt + 100) : 0,
    });
  };

  const onChangeIntigationFounds = (value) => {
    let calFeeCourt;
    if (value <= 300000) {
      calFeeCourt = value * 0.02;
      if (calFeeCourt > 1000) {
        calFeeCourt = 1000;
      }
    } else {
      calFeeCourt = value * 0.02;
    }

    form.setFieldsValue({
      courtFee: value ? Math.ceil(calFeeCourt + 100) : 0,
    });
  };

  const onChangeLawyer = (value) => {
    console.log("va", value);
    const jobs =
      loadLawyerJobs.find((o) => o.USER_ID === value)?.USER_JOBS ?? 0;

    console.log("job", jobs);
    setJobCont(jobs);
    form.setFieldsValue({ lawyerJobs: jobs }); // <- สำคัญมาก
  };

  const detailLoan = () => {
    return (
      <>
        <Divider>สถานะ</Divider>
        <div
          style={{
            marginBottom: "16px",
            padding: "12px",
            border: "1px solid #e8e8e8",
            borderRadius: "8px",
          }}
        >
          <Row gutter={16}>
            {dataDefault.investigationDate ? (
              <>
                <Col span="12">
                  <strong>วันที่สืบทรัพย์:</strong>{" "}
                  {convertDateThai(dataDefault.investigationDate)}
                </Col>
                <Col span="12">
                  <p
                    style={{
                      color:
                        dataDefault.investigationStatus === 7 ||
                        dataDefault.investigationStatus === 1
                          ? "green"
                          : dataDefault.investigationStatus === 5
                          ? "blue"
                          : "red",
                    }}
                  >
                    {dataDefault.investigationStatus === 7 ||
                    dataDefault.investigationStatus === 1
                      ? "เจอทรัพย์"
                      : dataDefault.investigationStatus === 5
                      ? "กำลังสืบทรัพย์"
                      : "ไม่เจอทรัพย์"}
                  </p>
                </Col>
              </>
            ) : (
              <Col span={24} style={{ textAlign: "center" }}>
                <p style={{ color: "red" }}>ยังไม่สืบทรัพย์</p>
              </Col>
            )}
          </Row>
        </div>
        {dataDefault.wcc.length ? (
          <>
            {dataDefault.wcc.map((item, index) => (
              <div
                key={index}
                style={{
                  marginBottom: "16px",
                  padding: "12px",
                  border: "1px solid #e8e8e8",
                  borderRadius: "8px",
                }}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <strong>ประเภทลูกค้า:</strong>{" "}
                    {item.customerTypeID === 0
                      ? "ผู้เช่าซื้อ"
                      : `คนค้ำที่ ${item.customerTypeID}`}
                  </Col>
                  <Col span={12}>
                    <strong>วันที่ตอบกลับ:</strong>{" "}
                    {item.dateResponse
                      ? convertDateThai(item.dateResponse)
                      : "-"}
                  </Col>
                  <Col span={12}>
                    <strong>ชื่อ:</strong> {item.customerFullname || "-"}
                  </Col>
                  <Col span={12}>
                    <strong>สถานะ:</strong>{" "}
                    <span style={{ color: item.status ? "green" : "red" }}>
                      {item.status === 1
                        ? "ใบตอบกลับ"
                        : item.status === 2
                        ? "เว็บไปษณีย์"
                        : item.status === 3
                        ? "ตีกลับ"
                        : "ยังไม่ตอบ"}
                    </span>
                  </Col>
                </Row>
              </div>
            ))}
          </>
        ) : (
          <Col span={24} style={{ textAlign: "center" }}>
            <div
              style={{
                marginBottom: "16px",
                padding: "12px",
                border: "1px solid #e8e8e8",
                borderRadius: "8px",
              }}
            >
              <p style={{ color: "red" }}>ไม่มีบอกเลิก</p>
            </div>
          </Col>
        )}
      </>
    );
  };

  const formDataSet = () => {
    return (
      <>
        <Divider>รายละเอียดของสัญญา {dataLeasingCase?.contno}</Divider>
        <Form
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          form={form}
          layout="horizontal"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            lostProfitAmount: dataLeasingCase
              ? dataLeasingCase?.lost_profit_amount
              : 0,
          }}
        >
          <Form.Item label="วันที่ทำสัญญา">
            {dataLeasingCase ? convertDateThai(dataLeasingCase?.sdate) : "-"}
          </Form.Item>
          <Form.Item label="ยอดกู้">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.ncarcst || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ดอกเบี้ยเช่าซื้อ">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.netprofit || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ภาษีเช่าซื้อ">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.vatprc || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ยอดเช่าซื้อทั้งหมด">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.balanc || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="งวดทั้งหมด">
            {dataLeasingCase ? dataLeasingCase?.t_nopay || 0 : null} งวด
          </Form.Item>
          <Form.Item label="ค่างวด">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.tot_upay || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ชำระมาแล้ว">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.netpay || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="เงินที่จ่ายไม่เต็มงวด">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.payment || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ค่าส่งจดหมาย">
            {dataLeasingCase
              ? currencyFormatComma(dataLeasingCase?.collectionFee || 0)
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="รับฝาก">
            {dataLeasingCase
              ? currencyFormatComma(
                  dataLeasingCase?.total_hd_payment_amount || 0
                )
              : 0}{" "}
            บาท
          </Form.Item>
          <Form.Item label="ค้างงวด">
            {dataLeasingCase ? dataLeasingCase?.hldno || 0 : 0} งวด
          </Form.Item>
          <Form.Item label="ยอดคงเหลือ">
            {dataLeasingCase
              ? currencyFormatPoint(
                  dataLeasingCase?.balanc - dataLeasingCase?.netpay || 0
                )
              : 0}{" "}
            บาท
          </Form.Item>
          {statusModal === 2 ? (
            <>
              <Form.Item label="เลือกทุนทรัพย์ที่จะใช้ฟ้อง" name="litigation">
                <Radio.Group
                  label="เลือกทุนทรัพย์ที่จะใช้ฟ้อง"
                  name="litigation"
                  options={options}
                  onChange={onChangeInvestiGateResult}
                  value={radioStatus}
                />
              </Form.Item>
              <Form.Item
                label="จำนวนทุนทรัพย์"
                name="intigationFounds"
                rules={[
                  {
                    required: true,
                    message: "กรุณาใส่จำนวนทุนทรัพย์ !",
                  },
                ]}
              >
                <InputNumber
                  precision={1}
                  suffix="บาท"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  size="large"
                  placeholder="กรุณาใส่จำนวนทุนทรัพย์"
                  style={{ width: "80%", color: "black" }}
                  onChange={(value) => onChangeIntigationFounds(value)}
                />
              </Form.Item>
              <Form.Item
                label="ค่าขาดประโยชน์"
                name="lostProfitAmount"
                rules={[
                  {
                    required: true,
                    message: "กรุณาใส่ค่าขาดประโยชน์ !",
                  },
                ]}
              >
                <InputNumber
                  precision={2}
                  suffix="บาท"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  size="large"
                  placeholder="กรุณาใส่ค่าขาดประโยชน์"
                  style={{ width: "80%", color: "black" }}
                  value={dataLeasingCase?.lost_profit_amount || 0}
                />
              </Form.Item>
              <Form.Item
                label="ค่าธรรมเนียมศาล"
                name="courtFee"
                rules={[
                  {
                    required: true,
                    message: "กรุณาใส่ค่าธรรมเนียมศาล !",
                  },
                ]}
              >
                <InputNumber
                  precision={2}
                  suffix="บาท"
                  formatter={(value) =>
                    `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                  size="large"
                  placeholder="กรุณาใส่ค่าธรรมเนียมศาล"
                  style={{ width: "80%", color: "black" }}
                />
              </Form.Item>
            </>
          ) : null}
          <Form.Item
            label="เลือกผู้รับผิดชอบ"
            name="lawyerChoose"
            rules={[
              {
                required: true,
                message: "กรุณาเลือกผู้รับผิดชอบ !",
              },
            ]}
          >
            <Select
              showSearch
              onChange={onChangeLawyer}
              placeholder="เลือกผู้รับผิดชอบ"
              optionFilterProp="label"
              options={lawyersOption}
              style={{ width: "80%" }}
            />
          </Form.Item>
          {statusModal === 9 ? null : (
            <Form.Item label="งานฟ้องทั้งหมด" name="lawyerJobs">
              {jobCount} งาน
            </Form.Item>
          )}
          <Form.Item label="หมายเหตุ" name="memo">
            <TextArea
              rows={10}
              style={{ width: "80%", color: "black" }}
              onChange={(e) => onChangeInputMemo(e.target.value)}
            />
          </Form.Item>
          <div style={{ textAlign: "center" }}>
            <Button
              onClick={handleCancel}
              style={{ color: "red", marginRight: "20px" }}
            >
              ปิด
            </Button>

            <Button style={{ color: "green" }} htmlType="submit">
              บันทึก
            </Button>
          </div>
        </Form>
      </>
    );
  };

  return (
    <>
      <Modal
        title={`ส่งทนายฟ้องสัญญา`}
        open={open}
        onCancel={handleCancel}
        width={850}
        footer={null}
      >
        <Spin spinning={loading} size="large" tip=" Loading... ">
          {detailLoan()}
          {dataLeasingCase ? formDataSet() : null}
        </Spin>
      </Modal>
    </>
  );
};
export default SendToLawsuit;
